(function () {
  const targetId = window.__fcRedirectVariantId__;
  if (!targetId) return;

  window.__fcVariantGuardLoaded__ = true;

  // Исправить URL
  const url = new URL(window.location.href);
  url.searchParams.set('variant', targetId);
  window.history.replaceState({}, '', url.toString());

  function applyVariant() {
    // 1. Обновить скрытый select (для Shopify form)
    const sel = document.querySelector('select[name="id"]');
    if (sel) {
      sel.value = String(targetId);
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // 2. Найти и кликнуть кнопку варианта в Impulse
    // Impulse рендерит кнопки вида: <input type="radio" value="VARIANT_ID"> или <button data-value="...">
    const radioInput = document.querySelector(`input[type="radio"][value="${targetId}"]`);
    if (radioInput) {
      radioInput.checked = true;
      radioInput.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    // Fallback: кнопка с data-value
    const btn = document.querySelector(`[data-value="${targetId}"]`);
    if (btn) {
      btn.click();
      return;
    }

    // Fallback 2: dispatch варианта напрямую через Impulse ивент
    document.dispatchEvent(new CustomEvent('variant:change', {
      bubbles: true,
      detail: { variant: { id: targetId } }
    }));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyVariant);
  } else {
    applyVariant();
  }

  // Повтор через 500мс на случай если Impulse инициализируется позже
  setTimeout(applyVariant, 500);
})();